var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1725 13.9939C15.498 14.3193 15.498 14.8469 15.1725 15.1724C14.8471 15.4978 14.3194 15.4978 13.994 15.1724L9.99995 11.1784L6.00601 15.1724C5.68058 15.4978 5.15294 15.4978 4.8275 15.1724C4.50206 14.8469 4.50206 14.3193 4.82749 13.9939L8.82143 9.99986L4.82733 6.00583C4.50189 5.68039 4.50189 5.15276 4.82733 4.82733C5.15277 4.50189 5.68041 4.50189 6.00585 4.82733L9.99993 8.82134L13.9939 4.82734C14.3193 4.5019 14.8469 4.5019 15.1724 4.82733C15.4978 5.15277 15.4978 5.6804 15.1724 6.00584L11.1784 9.99984L15.1725 13.9939Z",
    fill: "#858D9D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.9952cca03e6900fecc4438b658462de4.svg";
export { ForwardRef as ReactComponent };